var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('HeroSection',{attrs:{"id":"hero"}}),_c('AboutSection',{attrs:{"id":"about"}}),_c('ExperienceSection',{attrs:{"id":"experience"}}),_c('SkillsSection',{attrs:{"id":"skills"}}),_c('CTASection',{attrs:{"id":"contact"}}),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }